module.exports = __webpack_public_path__ + "static/media/02_quote_tablet.c49a2a48.jpg";